import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/gzoo/repo/frontend/src/app/book/[slug]/BookingClient.tsx");
